import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationTaskTrackerCommentCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новый комментарий к задаче</div>
            <div className='vm-notification__description'>
                Добавлен новый комментарий к задаче <UiNavLink to={ROUTES.TASK_TRACKER_TASK(notification.data.task.id)} onClick={onClose}>[№{notification.data.task.id}] {notification.data.task.name}</UiNavLink>
            </div>
        </div>
    );
});
